import { render, staticRenderFns } from "./NotificationServerErrorsModal.vue?vue&type=template&id=efa6c23c&scoped=true&"
import script from "./NotificationServerErrorsModal.vue?vue&type=script&lang=js&"
export * from "./NotificationServerErrorsModal.vue?vue&type=script&lang=js&"
import style0 from "./NotificationServerErrorsModal.vue?vue&type=style&index=0&id=efa6c23c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa6c23c",
  null
  
)

export default component.exports